// extracted by mini-css-extract-plugin
export default {"page":"K0-z","cartModal":"L0-z","checkout":"M0-z","placeholder":"N0-z","account":"O0-z"};